import React from 'react';
import { Box, Flex, IconButton, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);
const MotionFlex = motion(Flex);
const MotionStack = motion(Stack);

const fadeInUpVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.6, -0.05, 0.01, 0.99] }
  }
};

export default function Footer() {
  const bgColor = useColorModeValue('white', 'black');
  const textColor = useColorModeValue('gray.600', 'gray.400');
  const iconColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <MotionBox
      bg={bgColor}
      color={textColor}
      initial="hidden"
      animate="visible"
      variants={fadeInUpVariants}
    >
      <Box py={10}>
        <MotionFlex
          align={'center'}
          _before={{
            content: '""',
            borderBottom: '1px solid',
            borderColor: useColorModeValue('gray.200', 'gray.700'),
            flexGrow: 1,
            mr: 8,
          }}
          _after={{
            content: '""',
            borderBottom: '1px solid',
            borderColor: useColorModeValue('gray.200', 'gray.700'),
            flexGrow: 1,
            ml: 8,
          }}
        >
          <Text fontSize="2xl" fontWeight="bold">
            Riccardo Moi
          </Text>
        </MotionFlex>
        <Text pt={6} fontSize={'sm'} textAlign={'center'}>
          © {new Date().getFullYear()} Riccardo Moi. All rights reserved.
        </Text>
        <MotionStack direction={'row'} spacing={6} justify={'center'} align={'center'} mt={4}>
          <IconButton
            as="a"
            href="https://github.com/rickylachow"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            icon={<FaGithub />}
            size="lg"
            color={iconColor}
            variant="ghost"
          />
          <IconButton
            as="a"
            href="https://www.linkedin.com/in/riccardo-moi/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            icon={<FaLinkedin />}
            size="lg"
            color={iconColor}
            variant="ghost"
          />
        </MotionStack>
      </Box>
    </MotionBox>
  );
}